export default "__VITE_ASSET__WhdS6kHE__"